/* global window */

import { getCheckoutUrl } from '../../helpers/map-helpers';
import PaymentSelector from '../payment-selector/payment-selector.vue';
import * as types from '../../store/mutation-types';
import PhotoSelector from '../photo-selector/photo-selector.vue';

const ENTITY_TYPE = 'f';

export default {
  components: { PaymentSelector, PhotoSelector },
  props: {
    projects: { type: Array, required: true },
    slug: { type: String, required: true },
  },
  data() {
    return {
      coupon: null,
      errorExchanging: null,
      exchangingCoupon: false,
      form: {
        name: '',
        email: '',
        paymentMethod: 'paypal',
        plotSize: null,
        projectId: null,
        pictureId: null,
      },
      uploadStatus: false,
      uploadError: [],
      selectedProject: {},
      searchingPlot: false,
    };
  },
  computed: {
    isFormComplete() {
      return this.form.name !== '' && this.form.email !== '' && this.form.projectId !== null &&
        this.isImageUploaded && this.form.plotSize !== null;
    },
    isImageUploaded() {
      return this.uploadStatus === 'uploaded';
    },
  },
  methods: {
    selectProject() {
      if (!this.form.projectId) {
        this.selectedProject = null;
      } else {
        this.projects.forEach((proj) => {
          if (proj.id == this.form.projectId) {
            this.selectedProject = proj;
          }
        });
      }
    },
    checkAndEnableUpload(selectedFile) {
      if (selectedFile.errors.length) {
        this.uploadError = selectedFile.errors;
      } else {
        this.uploadStatus = 'ready';
        this.uploadError = [];
      }
    },
    dispatchExchange() {
      this.exchangingCoupon = true;
      this.errorExchanging = false;
      this.searchingPlot = true;
      this.$store.dispatch('exchangePurchase', this.getPurchaseParams())
        .then(response => {
          window.location.href = response.purchase.fullMapPath;
          this.exchangingCoupon = false;
        })
        .catch(err => {
          this.exchangingCoupon = false;
          this.errorExchanging = err;
        });
    },
    dispatchPurchase() {
      this.errorExchanging = false;
      this.searchingPlot = true;
      this.$store.dispatch('createsPurchaseWithPlot', this.getPurchaseParams())
        .then(response => {
          window.location.href = getCheckoutUrl({
            token: response.purchase.apiToken,
            paymentMode: this.form.paymentMethod,
          });
          this.exchangingCoupon = false;
        })
        .catch(err => {
          this.exchangingCoupon = false;
          this.errorExchanging = err;
        });
    },
    getPurchaseParams() {
      const purchase = {
        projectId: this.form.projectId,
        name: this.form.name,
        email: this.form.email,
        uploadIdentifier: this.form.uploadIdentifier,
        entityType: ENTITY_TYPE,
        entitySlug: this.slug,
        pictureId: this.form.pictureId,
      };

      if (this.coupon) {
        purchase.couponId = this.coupon.id;
      } else {
        purchase.plotSize = this.form.plotSize;
      }
      return purchase;
    },
    submitPurchase() {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            if (this.form.paymentMethod === 'coupon') {
              this.dispatchExchange();
            } else {
              this.dispatchPurchase();
            }
          } else {
            console.log('Corrects errors before submitting.');
          }
        });
      this.searchingPlot = false;
    },
    updateCoupon(coupon) {
      if (coupon) {
        this.coupon = coupon;
        if (this.coupon.available) {
          this.$store.commit(types.SAVE_COUPON, this.coupon.code);
        }
      } else {
        this.$store.commit(types.RESET_COUPON);
        this.coupon = {};
      }
    },
    uploadDone() {
      this.uploadStatus = 'uploaded';
    },
  },
};
